import { useState } from "react";
import { Share2, Link2, Check } from "lucide-react";

const SHARE_UTM = "utm_source=share&utm_medium=social&utm_campaign=event_share";

// Frictionless sharing of a high-intent event page. Links carry UTM params so shares are
// attributable in analytics once GA is connected. Self-contained (no Toaster dependency).
export const ShareBar = ({ title, path, className = "" }) => {
  const [copied, setCopied] = useState(false);
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const url = `${origin}${path}${path.includes("?") ? "&" : "?"}${SHARE_UTM}`;
  const text = `${title} — where to stay for the game`;
  const enc = encodeURIComponent;
  const targets = [
    { key: "x", label: "X", href: `https://twitter.com/intent/tweet?text=${enc(text)}&url=${enc(url)}` },
    { key: "facebook", label: "Facebook", href: `https://www.facebook.com/sharer/sharer.php?u=${enc(url)}` },
    { key: "whatsapp", label: "WhatsApp", href: `https://wa.me/?text=${enc(`${text} ${url}`)}` },
  ];

  const nativeShare = async () => {
    if (typeof navigator !== "undefined" && navigator.share) {
      try { await navigator.share({ title, text, url }); } catch (_) { /* user dismissed */ }
    }
  };
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (_) { /* clipboard blocked */ }
  };

  return (
    <div data-testid="event-share-bar" className={`flex flex-wrap items-center gap-2 ${className}`}>
      <button type="button" data-testid="event-share-native" onClick={nativeShare}
        className="inline-flex items-center gap-2 text-sm font-heading font-bold text-foreground/70 hover:text-primary transition-colors">
        <Share2 className="h-4 w-4" /> Share this trip
      </button>
      {targets.map((t) => (
        <a key={t.key} data-testid={`event-share-${t.key}`} href={t.href} target="_blank" rel="noopener noreferrer"
          className="rounded-full border border-border bg-card px-3 py-1.5 text-sm font-medium hover:border-primary hover:text-primary transition-colors">
          {t.label}
        </a>
      ))}
      <button type="button" data-testid="event-share-copy" onClick={copy}
        className="inline-flex items-center gap-1.5 rounded-full border border-border bg-card px-3 py-1.5 text-sm font-medium hover:border-primary hover:text-primary transition-colors">
        {copied ? <><Check className="h-4 w-4 text-primary" /> Copied</> : <><Link2 className="h-4 w-4" /> Copy link</>}
      </button>
    </div>
  );
};
